export default __webpack_public_path__ + "static/media/stt.07a40f8f.png";